var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItsmarcosjreyesHeaderSmallConsultingLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "630px",
    height: "630px",
    viewBox: "0 0 630 630",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "itsmarcosjreyes-header-small-consulting-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "itsmarcosjreyes-header-small-consulting-logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset-461",
    transform: "translate(78.000000, 79.000000)",
    fill: "#FF5B00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.5,355 C171.054257,355 118,301.945743 118,236.5 C118,171.054257 171.054257,118 236.5,118 C301.945743,118 355,171.054257 355,236.5 C355,267.928154 342.515214,298.069093 320.292154,320.292154 C298.069093,342.515214 267.928154,355 236.5,355 Z M236.5,137.75 C181.961881,137.75 137.75,181.961881 137.75,236.5 C137.75,291.038119 181.961881,335.25 236.5,335.25 C291.038119,335.25 335.25,291.038119 335.25,236.5 C335.25,210.309872 324.846012,185.192423 306.326795,166.673205 C287.807577,148.153988 262.690128,137.75 236.5,137.75 L236.5,137.75 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.5,404 C107.40146,404 5.79795322,248.422059 1.56036757,241.820588 C-0.520122523,238.578484 -0.520122523,234.421516 1.56036757,231.179412 C5.79795322,224.577941 107.40146,69 236.5,69 C365.59854,69 467.202047,224.577941 471.439632,231.179412 C473.520123,234.421516 473.520123,238.578484 471.439632,241.820588 C467.202047,248.422059 365.59854,404 236.5,404 Z M21.7628108,236.5 C40.6841235,263.595588 130.954553,384.294118 236.5,384.294118 C342.045447,384.294118 432.315877,263.595588 451.237189,236.5 C432.315877,209.404412 342.045447,88.7058824 236.5,88.7058824 C130.954553,88.7058824 40.6841235,209.404412 21.7628108,236.5 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8,99 L0,99 L0,9.9 C0,4.43238098 4.43238098,0 9.9,0 L99,0 L99,19.8 L19.8,19.8 L19.8,99 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473,99 L453.2,99 L453.2,19.8 L374,19.8 L374,0 L463.1,0 C468.567619,0 473,4.43238098 473,9.9 L473,99 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.1,473 L374,473 L374,453.2 L453.2,453.2 L453.2,374 L473,374 L473,463.1 C473,468.567619 468.567619,473 463.1,473 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,473 L9.9,473 C4.43238098,473 0,468.567619 0,463.1 L0,374 L19.8,374 L19.8,453.2 L99,453.2 L99,473 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.998703,246.168165 C171.869006,242.319524 178.122183,242.323164 181.988002,246.176308 L217.285344,281.357914 L217.285344,281.357914 L292.008087,206.96375 C295.876702,203.112147 302.130361,203.110262 306.001297,206.959532 C309.842961,210.779695 309.860391,216.990833 306.040228,220.832497 C306.0261,220.846705 306.011928,220.860869 305.997712,220.874991 L224.330341,302.001647 C220.43154,305.874634 214.138019,305.875771 210.237819,302.004192 L168.0048,260.081094 C164.161178,256.265678 164.138313,250.056801 167.953728,246.213179 C167.968671,246.198126 167.983663,246.183121 167.998703,246.168165 Z",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItsmarcosjreyesHeaderSmallConsultingLogo);
export default __webpack_public_path__ + "static/media/itsmarcosjreyes-header-small-consulting-logo.d3f5d01abcc726d46701fcdcc0bfa36d.svg";
export { ForwardRef as ReactComponent };